import { fetchAuthSession } from 'aws-amplify/auth';
import { setContext } from '@apollo/client/link/context';
import { createHttpLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { env } from 'core/config/environment';
import { AWS_REGION } from '../amplify/config/constants';
import { organizationLocalStorageItem } from 'services/organization/atom';
import { RetryableSubscriptionLink } from './RetryableSubscriptionLink';

const getAuthLink = (organizationId: string) => {
  return setContext(async (_, { headers }) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      return {
        headers: {
          ...headers,
          'organization-id': organizationId,
          authorization: `Bearer ${token}`
        }
      };
    } catch (error) {
      console.error('Error fetching AWS Amplify token:', error);
      return {
        headers
      };
    }
  });
};

const getSubscriptionLink = () => {
  return createSubscriptionHandshakeLink({
    url: env.GRAPHQL_ENDPOINT,
    region: AWS_REGION,
    auth: {
      type: 'AMAZON_COGNITO_USER_POOLS',
      jwtToken: async () => {
        const session = await fetchAuthSession();
        return session.tokens?.idToken?.toString() || '';
      }
    }
  });
};

export const getApolloClientLink = (newOrganizationId?: string) => {
  const organization = organizationLocalStorageItem();
  const organizationId = newOrganizationId || organization?.id || '';
  const httpLink = createHttpLink({
    uri: env.GRAPHQL_ENDPOINT
  });
  const link = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    new RetryableSubscriptionLink(getSubscriptionLink()), // Use WebSocket for subscriptions with auto-retry
    getAuthLink(organizationId).concat(httpLink) // Use HTTP for queries and mutations
  );
  return link;
};
